// =============================================
// components/forms/TrafficInsuranceForm.js
// BASİT HAL - SADECE 5 ALAN
// =============================================

import React, { useMemo, useCallback } from 'react';
import { Form, Row, Col, Card, InputGroup } from 'react-bootstrap';
import { FaShieldAlt, FaCalendarAlt, FaCreditCard, FaMoneyBillWave } from 'react-icons/fa';

const TrafficInsuranceForm = React.memo(({
    data,
    handleChange,
    mode = 'add',
    vehicleStatus = 'active',
    disabled = false
}) => {
    // ✅ SAFE DATA ACCESS
    const trafficInsurance = useMemo(() => {
        if (!data?.trafficInsurance) {
            return {
                startDate: '',
                endDate: '',
                insuranceAmount: 0,
                refundAmount: 0,
                paymentCardName: ''
            };
        }

        // ✅ ISO DATE STRING → HTML DATE INPUT FORMAT  
        const formatDateForInput = (isoString) => {
            if (!isoString) return '';
            return isoString.split('T')[0]; // "2025-06-02T00:00:00.000Z" → "2025-06-02"
        };

        return {
            startDate: formatDateForInput(data.trafficInsurance.startDate),
            endDate: formatDateForInput(data.trafficInsurance.endDate),
            insuranceAmount: data.trafficInsurance.insuranceAmount || 0,
            refundAmount: data.trafficInsurance.refundAmount || 0,
            paymentCardName: data.trafficInsurance.paymentCardName || ''
        };
    }, [data?.trafficInsurance]);

    // ✅ EVENT HANDLER
    const handleInsuranceChange = useCallback((field, value) => {
        if (disabled) return;

        handleChange({
            target: {
                name: `trafficInsurance.${field}`,
                value: value,
                type: 'text',
                checked: undefined
            }
        });
    }, [handleChange, disabled]);

    return (
        <Card className="mb-4">
            <Card.Header className="bg-info text-white">
                <h5 className="mb-0">
                    <FaShieldAlt className="me-2" />
                    Trafik Sigortası
                </h5>
            </Card.Header>

            <Card.Body>
                <Row className="mb-3">
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label>
                                <FaCalendarAlt className="me-1 text-primary" />
                                Sigorta Başlangıç Tarihi
                            </Form.Label>
                            <Form.Control
                                type="date"
                                value={trafficInsurance.startDate}
                                onChange={(e) => handleInsuranceChange('startDate', e.target.value)}
                                disabled={disabled}
                                lang="tr-TR"
                            />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label>
                                <FaCalendarAlt className="me-1 text-primary" />
                                Sigorta Bitiş Tarihi
                            </Form.Label>
                            <Form.Control
                                type="date"
                                value={trafficInsurance.endDate}
                                onChange={(e) => handleInsuranceChange('endDate', e.target.value)}
                                disabled={disabled}
                            />
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="mb-3">
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label>
                                <FaMoneyBillWave className="me-1 text-warning" />
                                Sigorta Başlatma Bedeli
                            </Form.Label>
                            <InputGroup>
                                <Form.Control
                                    type="number"
                                    placeholder="0"
                                    value={trafficInsurance.insuranceAmount}
                                    onChange={(e) => handleInsuranceChange('insuranceAmount', Number(e.target.value))}
                                    disabled={disabled}
                                    min="0"
                                    step="0.01"
                                />
                                <InputGroup.Text>₺</InputGroup.Text>
                            </InputGroup>
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label>
                                <FaMoneyBillWave className="me-1 text-success" />
                                Sigorta İptal Geri Ödeme
                            </Form.Label>
                            <InputGroup>
                                <Form.Control
                                    type="number"
                                    placeholder="0"
                                    value={trafficInsurance.refundAmount}
                                    onChange={(e) => handleInsuranceChange('refundAmount', Number(e.target.value))}
                                    disabled={disabled}
                                    min="0"
                                    step="0.01"
                                />
                                <InputGroup.Text>₺</InputGroup.Text>
                            </InputGroup>
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="mb-3">
                    <Col md={12}>
                        <Form.Group>
                            <Form.Label>
                                <FaCreditCard className="me-1 text-success" />
                                Hangi Kartla Ödendi
                            </Form.Label>
                            <Form.Select
                                value={trafficInsurance.paymentCardName}
                                onChange={(e) => handleInsuranceChange('paymentCardName', e.target.value)}
                                disabled={disabled}
                            >
                                <option value="">Kart seçiniz</option>
                                <option value="KUVEYT TÜRK TİCARİ KART">KUVEYT TÜRK TİCARİ KART</option>
                                <option value="VAKIFBANK TİCARİ KART">VAKIFBANK TİCARİ KART</option>
                                <option value="ZİRAAT KATILIM TİCARİ KART">ZİRAAT KATILIM TİCARİ KART</option>
                                <option value="BAHADIR KİŞİSEL KART">BAHADIR KİŞİSEL KART</option>
                                <option value="ÖNDER KİŞİSEL KART">ÖNDER KİŞİSEL KART</option>
                                <option value="FATİH KİŞİSEL KART">FATİH KİŞİSEL KART</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
});

TrafficInsuranceForm.displayName = 'TrafficInsuranceForm';

export default TrafficInsuranceForm;